import { render, staticRenderFns } from "./whatwedo.vue?vue&type=template&id=fca73fb6&scoped=true"
import script from "./whatwedo.vue?vue&type=script&lang=js"
export * from "./whatwedo.vue?vue&type=script&lang=js"
import style0 from "./whatwedo.vue?vue&type=style&index=0&id=fca73fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca73fb6",
  null
  
)

export default component.exports